import type { SxProps, Theme } from '@mui/material/styles';
import { fieldBoxRootSx } from 'components/fieldBox/styles';

// Visual parity with legacy fieldBox: typography comes from fieldBoxRootSx
// (theme.typography.fontFamily = Archivo, body1 size, weight 400, lineHeight 38px).
export const labelledCardLayoutSx = {
  display: 'flex',
  alignItems: 'center',
} satisfies SxProps<Theme>;

export const getLabelledCardSx = (isClickable: boolean): SxProps<Theme> =>
  [
    fieldBoxRootSx,
    labelledCardLayoutSx,
    { cursor: isClickable ? 'pointer' : 'default' },
  ] as SxProps<Theme>;

export const labelledCardLabelSx = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} satisfies SxProps<Theme>;

export const labelledCardDeletedLabelSx = {
  opacity: 0.5,
} satisfies SxProps<Theme>;

export const labelledCardEndActionsSx = {
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
} satisfies SxProps<Theme>;
